import { createSlice } from "@reduxjs/toolkit"
import api from "../../api/services"
import { Step3Response } from "../../api/types/step3"

type initialState = {
    response: Step3Response | null
}

const step3Slice = createSlice({
    name: "step3",
    initialState: { response: null } as initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addMatcher(
            api.endpoints.step3.matchFulfilled,
            (state, action) => {
                state.response = action.payload
            }
        )
    }
})

export default step3Slice.reducer
